<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 158 354"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_825_125068)">
      <path d="M0.5 350.495C0.5 352.151 1.85189 353.5 3.51099 353.5C4.24837 353.5 4.92428 353.255 5.41587 352.825L134.826 271.505C148.651 260.834 157.5 244.154 157.5 225.388V3.50498C157.5 1.84914 156.148 0.5 154.489 0.5C153.752 0.5 153.076 0.74522 152.584 1.17451L23.1744 82.4947C9.34855 93.1656 0.5 109.847 0.5 128.613V350.495Z" :fill="fill"/>
    </g>
    <defs>
      <filter id="filter0_i_825_125068" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse" height="353" width="157" x="0.5" y="0.5">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape"/>
        <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="15"/>
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.725 0 0 0 0 0.634588 0 0 0 0 0.0845833 0 0 0 1 0"/>
        <feBlend in2="shape" mode="normal" result="effect1_innerShadow_825_125068"/>
      </filter>
    </defs>
  </svg>

</template>

<script>
export default {
  name: 'PwccMinimal',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
